export const confirm = {
  mounted(el: any, binding: any) {
    el.addEventListener("click", function (e: any) {
      e.preventDefault();
      const { message, handler } = binding.value;
      const template = `
        <div class="modal fade" data-keyboard="false" tabindex="-1" aria-labelledby=" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirmation</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h4>${message}</h4>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-confirm">Confirm</button>
                </div>
                </div>
            </div>
        </div>
      `;
      /*const dialog = $(template);
      $("body").append(dialog);
      dialog.modal({
        backdrop: false,
      });
      dialog.on("click", ".btn-confirm", function () {
        dialog.modal("hide");
        dialog.modal("dispose");
        dialog.remove();
        handler(el);
      });*/
    });
  },
};
